import { Rol } from '@shared/interfaces/rol';
import { Observable } from 'rxjs';

export const ROLES_REPOSITORY = 'RolesRepository';

export interface RolesRepository {
  getItems(): Observable<any>;

  getItemUser(): Observable<any>;

  getItemId(item: any): Observable<any>;

  add(rol: Rol): Observable<any>;

  edit(rol: Rol): Observable<any>;

  delete(item: any): Observable<any>;
}
